import api from './api';

export const groupService = {
  // Get all groups
  getAllGroups: async () => {
    const response = await api.get('/groups');
    return response.data;
  },

  // Get group by ID
  getGroupById: async (id) => {
    const response = await api.get(`/groups/${id}`);
    return response.data;
  },

  // Get group by name
  getGroupByName: async (name) => {
    const response = await api.get(`/groups/name/${name}`);
    return response.data;
  },

  // Search groups
  searchGroups: async (searchTerm) => {
    const response = await api.get(`/groups/search?searchTerm=${encodeURIComponent(searchTerm)}`);
    return response.data;
  },

  // Get groups by type
  getGroupsByType: async (groupTypeId) => {
    const response = await api.get(`/groups/type/${groupTypeId}`);
    return response.data;
  },

  // Get groups seeking members
  getGroupsSeekingMembers: async () => {
    const response = await api.get('/groups/seeking-members');
    return response.data;
  },

  // Get groups seeking members with member details
  getGroupsSeekingMembersWithMembers: async () => {
    const response = await api.get('/groups/seeking-members-with-members');
    return response.data;
  },

  // Get groups seeking members by type
  getGroupsSeekingMembersByType: async (groupTypeId) => {
    const response = await api.get(`/groups/seeking-members/type/${groupTypeId}`);
    return response.data;
  },

  // Get groups by creator
  getGroupsByCreator: async (createdBy) => {
    const response = await api.get(`/groups/creator/${createdBy}`);
    return response.data;
  },

  // Get groups by user ID
  getGroupsByUserId: async (userId) => {
    const response = await api.get(`/groups/user/${userId}`);
    return response.data;
  },

  // Get teams for household with member details
  getTeamsForHouseholdWithMembers: async (householdId) => {
    const response = await api.get(`/groups/household/${householdId}/teams-with-members`);
    return response.data;
  },

  // Create new group
  createGroup: async (groupData, createdBy) => {
    const response = await api.post(`/groups?createdBy=${createdBy}`, groupData);
    return response.data;
  },

  // Update group
  updateGroup: async (id, groupData, updatedBy) => {
    const response = await api.put(`/groups/${id}?updatedBy=${updatedBy}`, groupData);
    return response.data;
  },

  // Delete group
  deleteGroup: async (id, deletedBy) => {
    const response = await api.delete(`/groups/${id}?deletedBy=${deletedBy}`);
    return response.data;
  },

  // Add user to group
  addUserToGroup: async (userId, groupId, requestedBy) => {
    console.log('groupService.addUserToGroup called with:', { userId, groupId, requestedBy });
    const url = `/groups/${groupId}/users/${userId}?requestedBy=${requestedBy}`;
    console.log('Making API call to:', url);
    const response = await api.post(url);
    console.log('API response:', response);
    return response.data;
  }
}; 